// js
import { connect } from 'react-redux';
import OverviewArea from '../../../components/analytics/pptx/OverviewArea';
import { mapStateToProps, mapDispatchToProps } from '../OverviewArea';


export default connect(mapStateToProps, mapDispatchToProps)(OverviewArea);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/OverviewArea.js